import { yupResolver } from '@hookform/resolvers/yup'
import { InputAdornment, Stack } from '@mui/material'
import { useCallback } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { LabelsPartsInfo } from '../../../models/Labels'
import {
  useCreateCannedJobToInventoryProductMutation,
  useUpdateCannedJobToInventoryProductMutation
} from '../../../redux/api/cannedJobApi'
import {
  CannedJobCustomPartEntry,
  CannedJobCustomPartInfoUnitOfMeasureEnum,
  CannedJobInventoryPartInfo,
  CannedJobToInventoryProductEntry,
  CannedJobToInventoryProductInfo
} from '../../../sdk'
import { ControlledMuiTextField } from '../../FormField'
import { VALIDATE_SEARCH_PRODUCT_FOR_CANNEDJOB } from '../validation'

export const CannedJobProductForm = ({
  existingCannedJobToProductEntry,
  cannedJobId,
  selectedProduct,
  submitCallback
}: {
  existingCannedJobToProductEntry: CannedJobToInventoryProductEntry | undefined
  cannedJobId: string
  selectedProduct: CannedJobCustomPartEntry
  submitCallback: () => void
}) => {
  const { handleSubmit, control } = useForm<
    CannedJobToInventoryProductInfo & {
      unitOfMeasure: CannedJobCustomPartInfoUnitOfMeasureEnum
    }
  >({
    mode: 'onBlur',
    defaultValues: existingCannedJobToProductEntry
      ? existingCannedJobToProductEntry.info
      : {
          quantity: selectedProduct.info!.quantity || 1,
          inventoryProduct: selectedProduct.id!,
          cannedJob: cannedJobId,
          unitOfMeasure: selectedProduct.info!.unitOfMeasure
        },
    resolver: yupResolver(VALIDATE_SEARCH_PRODUCT_FOR_CANNEDJOB)
  })

  const { accessToken } = useAccessTokenAndShopId()

  const [create] = useCreateCannedJobToInventoryProductMutation()
  const [update] = useUpdateCannedJobToInventoryProductMutation()
  const onSubmit: SubmitHandler<CannedJobInventoryPartInfo> = useCallback(
    async (data) => {
      if (existingCannedJobToProductEntry) {
        update({
          authorization: accessToken,
          cannedJobToInventoryProductEntry: {
            id: existingCannedJobToProductEntry.id!,
            info: {
              ...existingCannedJobToProductEntry.info,
              ...data
            }
          }
        })
      } else {
        create({
          authorization: accessToken,
          cannedJobToInventoryProductInfo: {
            ...data,
            quantity: data.quantity || 0
          }
        })
      }
      submitCallback()
    },
    [
      existingCannedJobToProductEntry,
      submitCallback,
      update,
      accessToken,
      create
    ]
  )
  return (
    <form
      id={'searchInventoryForm'}
      onSubmit={handleSubmit((data) => {
        onSubmit({ ...data, inventoryPart: selectedProduct?.id! })
      })}>
      <Stack direction="row" alignItems={'center'} spacing={2} p={1}>
        <ControlledMuiTextField
          variant="standard"
          name="quantity"
          label={LabelsPartsInfo.quantity}
          control={control}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {selectedProduct.info!.unitOfMeasure}
              </InputAdornment>
            )
          }}
        />
      </Stack>
    </form>
  )
}
